import { useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { AbstractWallet } from '@blink/components/src/utils';
import { Contract, ethers } from 'ethers';

import { getWalletMap } from '@/shared/utils/getWalletMap';
import { getSafeContract } from '@/shared/utils/getSafeContract';
import { getSafeSigner } from '@/shared/utils/getSafeSigner';
import { Store } from '@/shared/store';

type UseWalletContractProps = {
    address: string;
    abi: any;
};

export const useWalletContract = ({ address, abi }: UseWalletContractProps) => {
    const { type, blockchainName } = useSelector((state: Store) => ({
        type: state.wallets.active.type,
        blockchainName: state.wallets.network,
    }));

    const [contract, setContract] = useState<Contract | null>(null);

    const getWalletContract = useCallback(async () => {
        if (!type || !blockchainName || !address) {
            return;
        }

        const walletMap = getWalletMap();
        const wallet: AbstractWallet = walletMap.get(type) as AbstractWallet;
        const walletProvider = await wallet.getProvider();

        const signer = await getSafeSigner(walletProvider, blockchainName);
        const walletContract = getSafeContract(address, abi, signer as ethers.Signer);

        setContract(walletContract);
    }, [type, blockchainName, address, abi]);

    useEffect(() => {
        getWalletContract();
    }, []);

    return contract;
};
